<div class="funds-modal">
  <header class="funds-modal__header">
    <div class="funds-modal__title-row">
      <h2 class="funds-modal__title">{{ texts.title }}</h2>
      <ds-icon-button-v2
        emphasis="secondary-filled"
        size="s"
        icon="Close"
        [ariaLabel]="texts.closeLabel"
        (clicked)="closeModal()"
      ></ds-icon-button-v2>
    </div>
  </header>

  <div class="funds-modal__body">
    <p class="funds-modal__intro">{{ texts.intro }}</p>

    <div class="funds-modal__faqs">
      <ds-accordion
        *ngFor="let faq of faqs; let i = index"
        shadow="l2"
        [border]="false"
        [expanded]="isOpen(i)"
        (expandedChange)="toggle(i)"
      >
        <span ds-accordion-header>{{ faq.question }}</span>
        <p ds-accordion-content>{{ faq.answer }}</p>
      </ds-accordion>
    </div>
  </div>
</div>
